(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fbt"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fbtInit) return;
    window.__fbtInit = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-fbt-form')) return;
      event.preventDefault();

      var button = form.querySelector('.fbt__button');
      var text = form.querySelector('.fbt__button-text');
      var root = form.closest('[data-fbt]');
      var status = root && root.querySelector('[data-fbt-status]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      var id = Number(form.querySelector('[name="id"]').value);
      var originalLabel = button.dataset.label;
      button.setAttribute('aria-busy', 'true');

      try {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        // Dawn-style themes (Dawn, Shrine, etc.): cart drawer or cart notification
        var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sectionIds = [];
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          sectionIds = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        }

        var payload = { id: id, quantity: 1 };
        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
          payload.sections_url = window.location.pathname;
        }

        var response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');

        text.textContent = button.dataset.addedLabel;
        if (status) status.textContent = button.dataset.addedLabel;

        if (root && root.dataset.afterAdd === 'cart') {
          window.location.href = root.dataset.cartUrl;
          return;
        }

        // Refresh and open the cart drawer / notification, update the header count
        if (cartEl && typeof cartEl.renderContents === 'function' && data.sections) {
          cartEl.renderContents(data);
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fbt', productVariantId: id, cartData: data });
        }
        ['cart:refresh', 'cart:updated'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'fbt' } }));
        });

        setTimeout(function () { text.textContent = originalLabel; }, 1800);
      } catch (error) {
        text.textContent = originalLabel;
        if (status) status.textContent = error.message;
        console.error('[FBT]', error);
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fbtInit) return;
    window.__fbtInit = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-fbt-form')) return;
      event.preventDefault();

      var button = form.querySelector('.fbt__button');
      var text = form.querySelector('.fbt__button-text');
      var root = form.closest('[data-fbt]');
      var status = root && root.querySelector('[data-fbt-status]');
      if (!button || !text || button.getAttribute('aria-busy') === 'true') return;

      var ids = Array.prototype.map.call(form.querySelectorAll('[name="id"]'), function (el) {
        return Number(el.value);
      });
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
      var originalLabel = button.dataset.label;
      button.setAttribute('aria-busy', 'true');

      try {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        // Dawn-style themes (Dawn, Shrine, etc.): cart drawer or cart notification
        var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sectionIds = [];
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          sectionIds = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        }

        var payload = { items: items };
        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
          payload.sections_url = window.location.pathname;
        }

        var response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');

        text.textContent = button.dataset.addedLabel;
        if (status) status.textContent = button.dataset.addedLabel;

        if (root && root.dataset.afterAdd === 'cart') {
          window.location.href = root.dataset.cartUrl;
          return;
        }

        // Refresh and open the cart drawer / notification, update the header count
        if (cartEl && typeof cartEl.renderContents === 'function' && data.sections) {
          cartEl.renderContents(data);
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fbt', productVariantId: ids[0], cartData: data });
        }
        ['cart:refresh', 'cart:updated'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'fbt' } }));
        });

        setTimeout(function () { text.textContent = originalLabel; }, 1800);
      } catch (error) {
        text.textContent = originalLabel;
        if (status) status.textContent = error.message;
        console.error('[FBT]', error);
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
